<template>
    <div class="loginBox">
        <div class="loginRight">
            <div class="rightInpBox">
                <div class="top">
                    欢迎<span>登录</span>
                </div>
                <div class="inpList">
                    <el-form :model="ruleForm2" status-icon :rules="rules2" ref="ruleForm2" class="demo-ruleForm">
                        <el-form-item prop="name">
                            <el-input placeholder="请输入用户名" prefix-icon="icon_user" v-model="ruleForm2.inpName"></el-input>
                        </el-form-item>
                        <el-form-item prop="pwd">
                            <el-input placeholder="请输入密码" prefix-icon="icon_pwd" type="password" v-model="ruleForm2.inpPwd" @keyup.enter.native="login"></el-input>
                        </el-form-item>
                        <el-form-item class="loginBtn">
                            <el-button type="primary" @click="login()">登录</el-button>
                            <div>
                                如有疑问请联系:&nbsp;<a href="mailto:service@aiyechen.com">service@aiyechen.com</a>
                            </div>
                            <div class="webyechen">
                                ➲&nbsp;<a href="http://www.aiyechen.com" target="_blank" class="aiyechen" title="野尘出品">野尘出品</a>
                            </div>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import { setTimeout, clearTimeout } from "timers";
import ssUtil from '@/utils/SStorage'

export default {
  name: "login",
  data() {
    var checkName = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("用户名不能为空"));
      } else if (this.ruleForm2.inpName.trim() == "") {
        callback(new Error("用户名不能为空"));
      } else {
        callback();
      }
    };
    var checkPwd = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        if (this.ruleForm2.inpPwd.trim() == "") {
          callback(new Error("密码不能为空"));
        }
        // else if (this.ruleForm2.inpPwd.length < 3) {
        //   callback(new Error("安全码不少于6位！"));
        // }
        callback();
      }
    };
    return {
        ruleForm2: {
            inpName: "",
            inpPwd: ""
        },
        rules2: {
            name: [{ validator: checkName, trigger: "blur" }],
            pwd: [{ validator: checkPwd, trigger: "blur" }]
        }
    };
  },
  methods: {
    //用户登录
    login() {
        let that = this;
        // if(this.ruleForm2.inpName.trim()==''){
        //     this.$message({
        //         message:'用户名不能为空',
        //         type:'error',
        //         center:true,
        //         showClose:false
        //     })
        //     return;
        // }
        // if(this.ruleForm2.inpPwd.trim()==''){
        //     this.$message({
        //         message:'密码不能为空',
        //         type:'error',
        //         center:true,
        //         showClose:false
        //     })
        //     return;
        // }
        this.$store.dispatch("login", { userName:this.ruleForm2.inpName,passWord:this.ruleForm2.inpPwd }).then(res => {
            this.$message({
                message: "登录成功",
                type: "success",
                center: true,
                showClose: false,
                duration: 600
            });
            const authToken = res.headers.authorization
            sessionStorage.setItem('authToken', authToken)
            this.$store.dispatch('setLoginState', true)
            ssUtil.setItem('isLogin',true)
            const userInfo = res.data.data
            this.$store.dispatch('userInfo', userInfo)
            ssUtil.setItem('userInfo',userInfo)
            let timer = setTimeout(function() {
                clearTimeout(timer);
                that.$router.push({
                    path: "/dashBoard"
                });
                // window.location.reload();
            },1000);
        })
        // }).catch(error => {
        //     this.$message({
        //         message: '系统异常',
        //         type: "error",
        //         center: true,
        //         showClose: false
        //     });
        // });
    }
  },
  mounted() {}
};
</script>
<style lang="scss" src="../sass/login.scss" scope ></style>



// WEBPACK FOOTER //
// src/view/login.vue